export default __webpack_public_path__ + "media/images/wood-for-stone-3a70c6e3b8d2f5b7c59d61d4318865ab.png";